import { ProcessingKey } from 'constants/rootConstants'
import { useZustandStore } from 'zustandGlobalStore'
import { createCohortLead } from './createCohortLead'
import { createLead } from './createLead'
import { fetchGeoData } from './fetchGeoData'
import { fetchLead } from './fetchLead'

export const getFirstLead = async (): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.GET_FIRST_LEAD)

  const searchParams = new URLSearchParams(window.location.search)
  const leadIdFromUrl = searchParams.get('uuid')

  const leadIdFromStore = useZustandStore.getState().lead?.id
  const leadId = leadIdFromUrl || leadIdFromStore
  const initialCohort = useZustandStore.getState().initialCohort

  if (leadId) {
    await Promise.all([fetchLead(leadId), fetchGeoData()])

    const cohort = useZustandStore.getState().lead?.cohort

    if (initialCohort !== cohort) {
      await createCohortLead()
    }

    useZustandStore.getState().stopProcessing(ProcessingKey.GET_FIRST_LEAD)
    return
  }

  await createLead()

  useZustandStore.getState().stopProcessing(ProcessingKey.GET_FIRST_LEAD)
}
